export default __webpack_public_path__ + "static/media/TeamsAssets-Light.66561737.ttf";